/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect, useRef } from 'react';
import { Input, Table, ConfigProvider, Button, Space, Spin ,Tooltip} from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { request } from '@/utils'

import Highlighter from 'react-highlight-words';
import './index.scss'
import zhCN from 'antd/locale/zh_CN';




const Tcardlog = () => {
  const [spinning, setSpinning] = useState(false);
  const [bangm, setbangm] = useState([]);





  useEffect(() => {
    async function getau() {
      const res = await request.post('/ptc_list', { zt: 'Y' })
      // const res = await request.post('/ptc_list')
      setbangm(res.rescode)
      setSpinning(false)
    }

    getau()

  }, [])


  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const searchInput = useRef(null);
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText('');
  };
  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          ref={searchInput}
          placeholder={`检索内容`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{
            marginBottom: 8,
            display: 'block',
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            检索
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{
              width: 90,
            }}
          >
            重置
          </Button>

          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            关闭
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? '#1677ff' : undefined,
        }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    filterDropdownProps: {
      onOpenChange(open) {
        if (open) {
          setTimeout(() => searchInput.current?.select(), 100);
        }
      },
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: '#ffc069',
            padding: 0,
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ''}
        />
      ) : (
        text
      ),
  });




  const columns = [{
    title: '编号',
    dataIndex: 'key',
    key: 'key',
    sorter: (a, b) => a.key - b.key,
    sortDirections: ['descend', 'ascend'],

    render: (_, record) => (
      <Space size="middle">
       <Tooltip title={`快递:${record.th_json.kdmc}     单号：${record.th_json.kdbill}` }color='green'>{record.key} </Tooltip>
       </Space>
    ),

  },
  {
    title: '提货时间',
    dataIndex: 'dtime',
    key: 'dtime',
    ...getColumnSearchProps('dtime'),
  },
  {
    title: '收件人',
    dataIndex: 'shmc',
    key: 'shmc',
    ...getColumnSearchProps('shmc'),
    // render: (_, record) => { const list=record.th_json.shmc
    //   console.log("lsit",list)
    // return list
    // },
  },
  {
    title: '联系电话',
    key: 'shphone',
    dataIndex: 'shphone',
    ...getColumnSearchProps('shphone'),
  },

  {
    title: '地址',
    dataIndex: 'address',
    key: 'address',
    ...getColumnSearchProps('address'),
  },

  ];

  return (
    <>

      <ConfigProvider locale={zhCN} >


        <Table columns={columns} dataSource={bangm} />


        <Spin spinning={spinning} tip="数据整理中，请稍等..." fullscreen />

      </ConfigProvider>
    </>

  );
};
export default Tcardlog;